import jsPDF from "jspdf";
import arabicToThai from "../../../../../hook/arabicToThai";
import oneBell from "../../../../../assets/images/license/oneBell.png";
import oneJumbo from "../../../../../assets/images/license/3.png";
import signature_sakon from "../../../../../assets/images/license/24.png";
import dayjs from "dayjs";
import CurrencyFormat from "../../../../../hook/CurrencyFormat";
import "../../../../../assets/font/THSarabunNew-normal";
import "../../../../../assets/font/THSarabunNew-bold";

export async function createPdfRePrintAcc1(data = [], selectedContract, totalCount, startOffset = 0, lawyer = "sakon") {
  const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  console.log("data", data);

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "A4",
  });

  // const AAA = "AAA"

  data?.forEach((person, index) => {
    // let calNOPAY = (person?.NOPAY - 1)
    // let calDate = (dayjs(person?.FirstUnpaidDate).subtract(calNOPAY, "month").format("YYYY-MM-DD"))
    // console.log("calNOPAY", calNOPAY)
    // console.log("calDate", calDate)
    if (index !== 0) pdf.addPage();

    // let y = 20;
    let y = 15;
    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(16);

    // ส่วนหัว
    pdf.text(`กรุณาส่ง`, 25, y);
    // y += 5;
    // y += 10;

    pdf.text(
      `${person.customerFullname} (${person.CONTNO}) (${person.customerTypeId === 0 ? "ผู้กู้/จำนอง" : "ผู้ค้ำประกัน " + person.customerTypeId})`,
      40,
      y,
    );
    y += 5;

    // pdf.text(`${index + 1}/${currentBatchNumber}`, 180, y);
    pdf.text(`${startOffset + index + 1}/${totalCount}`, 180, y);

    pdf.text(person.ADDR1 ? person.ADDR1 : "-", 40, y);

    y += 5;
    pdf.text(
      `ต.${person.TUMB ? person.TUMB : "-"} อ.${
        person.AUMPDES ? person.AUMPDES : "-"
      } จ.${person.PROVDES ? person.PROVDES : "-"}`,
      40,
      y,
    );
    y += 5;
    pdf.text(person.ZIP, 40, y);

    y += 5;
    pdf.text(person.TELP, 40, y);

    y += 5;
    pdf.text(`(${dayjs(person.datetime).format("DD/MM/YYYY")})`, 40, y);

    // y += 38;
    y += 53;
    pdf.setFontSize(14);
    pdf.text(
      `วันที่ ${dayjs(person.datetime).add(543, "year").format("D MMMM YYYY")}`,
      150,
      y,
    );
    pdf.text(
      `เรื่อง   ขอให้ชำระหนี้/บอกกล่าวบังคับจำนอง เลขที่ (${person.CONTNO})`,
      20,
      y,
    );
    y += 5;
    pdf.text(
      `เรียน   ${person.BSNAM} ${person.BNAME1} ${person.BNAME2} (ผู้กู้/จำนอง)`,
      20,
      y,
    );

    let xLeft = 30;
    let xRight = 120;
    let yGUARANTORS = y + 5;

    // เรียง GARNO จากน้อย -> มาก (0,1,2,...)  ถ้าไม่มีค่าให้ไปท้ายสุด
    const sortedGuarantors = [...(person?.guarantor ?? [])].sort((a, b) => {
      const ga = Number(a?.garno ?? Number.POSITIVE_INFINITY);
      const gb = Number(b?.garno ?? Number.POSITIVE_INFINITY);
      return ga - gb; // asc
    });

    sortedGuarantors.forEach((g, i) => {
      const x = i % 2 === 0 ? xLeft : xRight;

      pdf.text(
        `${g.snam} ${g.name1} ${g.name2} (${
          Number(g?.garno) === 0 ? "ผู้กู้" : `ผู้ค้ำประกัน ${Number(g?.garno)}`
        })`,
        x,
        yGUARANTORS,
      );

      // ครบ 2 คนในแถวแล้วค่อยขึ้นบรรทัดใหม่
      if (i % 2 === 1) yGUARANTORS += 5;
    });

    // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
    y = yGUARANTORS + 15;

    // pdf.text(`อ้างถึง  สัญญาจำนองที่ดิน ${person.CONTNO} ลงวันที่ ${AAA} และวันที่ ${AAA}`, 20, y);
    // pdf.text(`อ้างถึง  สัญญาจำนองที่ดิน ${person.CONTNO} ลงวันที่ ${dayjs(person.FDATE).format("DD MMMM YYYY")} และวันที่ ${dayjs(person.LDATE).format("DD MMMM YYYY")}`, 20, y);
    // y += 5;

    const NBSP = "\u00A0";
    const nowrap = (s) => String(s ?? "").replace(/ /g, NBSP);
    const glue = (...parts) => parts.filter(Boolean).join(NBSP); // ต่อคำด้วย NBSP
    const amountLoan = glue(currencyFormatPoint(person?.NCSHPRC), "บาท");
    const amountTotal = glue(currencyFormatPoint(person?.TOTPRC), "บาท");
    const amountInstal = glue(currencyFormatPoint(person?.TOT_UPAY), "บาท");
    const arrearAmount = currencyFormatPoint(person?.EXP_AMT);
    const arrearAmountThai = numberToThaiText(person?.EXP_AMT);

    const signDate = dayjs(person.SDATE)
      .add(543, "year")
      .format("DD MMMM YYYY");
    const BNAMEnew = person?.BSNAM + person?.BNAME1 + person?.BNAME2;
    const startDate = nowrap(
      dayjs(person?.FDATE).add(543, "year").format("DD MMMM YYYY"),
    );
    const lastDueDate = nowrap(
      dayjs(person?.LDATE).add(543, "year").format("DD MMMM YYYY"),
    );

    const indent = "          "; // เว้นบรรทัดเริ่มต้นแบบย่อหน้า (ประมาณ 8 ช่องว่าง)
    y += 5;
    const content = [
      `${indent}ตามที่ท่าน ${BNAMEnew} ได้กู้ยืมเงินไปจาก บริษัท วัน มันนี่ จำกัด (สำนักงานใหญ่) เมื่อวันที่ ${signDate} 
เป็นเงินจำนวน ${amountLoan} (${numberToThaiText(person?.NCSHPRC)}) ดอกเบี้ยอัตราร้อยละ 15 ต่อปี และตกลงนำส่งดอกเบี้ย
เป็นรายเดือน เดือนละ 1 ครั้งเสมอไป โดยกำหนดชำระเงินต้นพร้อมดอกเบี้ยงวดละ ${amountInstal} กำหนดชำระงวดแรกวันที่ 
${startDate} และงวดถัดไปชำระทุกวันที่ ${dayjs(person?.LDATE).format("D")} ของเดือน รวมเป็นเงินตลอดสัญญาทั้งสิ้น จำนวน ${amountTotal} และท่านได้ทำ
สัญญา จำนองที่ดิน เลขที่ ${person.COLOR ?? ""} ${person.STRNO ?? ""} ตำบล${person?.BAAB ?? ""} อำเภอ${person?.MODEL ?? ""} จังหวัด${person?.TYPE ?? ""} เป็นหลักประกันหนี้กู้ยืมเงินดังกล่าว โดยผู้กู้ได้รับเงินกู้ยืมไปจากผู้ให้กู้ครบถ้วนแล้วและในการกู้ยืมเงินครั้งนี้ท่านได้ทำสัญญาค้ำประกันเพื่อประกันหนี้โดยตกลงจะชำระหนี้แทนเมื่อผู้กู้ ไม่ชำระหนี้นั้น`,

      `${indent}บัดนี้ปรากฏว่า ผู้กู้ผิดนัด และค้างชำระหนี้กู้ยืม งวดที่ ${person?.EXP_FRM} - ${person?.EXP_TO} โดยมีหนี้ต้นเงินค้างชำระ ${person?.EXP_PRD} งวด เป็นจำนวนเงิน ${glue(arrearAmount, "บาท")} (${arrearAmountThai}) ผู้ให้กู้และผู้รับจำนองจึงขอให้ท่านนำเงินดังกล่าวพร้อมดอกเบี้ยมาชำระให้เสร็จ
สิ้นและไถ่ถอนจำนอง ณ ที่ทำการของผู้ให้กู้และผู้รับจำนองภายใน 60 วัน นับแต่วันที่ท่านได้รับหนังสือ ฉบับนี้หากพ้นกำหนดดังกล่าวแล้วท่านเพิกเฉยละเลยไม่ปฏิบัติตามคำบอกกล่าวตามหนังสือฉบับนี้ผู้ให้กู้และผู้รับจำนองมีความจำเป็นที่จะต้องใช้สิทธิในทางศาล เพื่อบังคับจำนองตามกฎหมายต่อไป`,

      `${indent}หากท่านมีการชำระเงินจำนวนดังกล่าวเป็นที่เรียบร้อยแล้ว ทางบริษัทฯ ต้องขออภัย ณ โอกาสนี้`,
    ];

    content.forEach((line) => {
      const splitText = pdf.splitTextToSize(line, 170);
      pdf.text(splitText, 20, y);
      y += splitText.length * 6;
    });

    y += 10;

    pdf.text(`ขอแสดงความนับถือ`, 47, y + 2); // (x, y)
    let imageWidthImg = 25; // Adjust width to fit your needs
    let imageHeightImg = 15; // Adjust height to fit your needs
    if (lawyer === "pongsara") {
      pdf.addImage(oneJumbo, "PNG", 50, y + 3, imageWidthImg - 3, imageHeightImg - 3);
      pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 20); // (x, y)
    } else {
      pdf.addImage(signature_sakon, "PNG", 50, y + 3, imageWidthImg - 3, imageHeightImg - 3);
      pdf.text("(นายสกล พัดริม)", 50, y + 20); // (x, y)
    }
    pdf.text("ทนายความประจำบริษัทฯ", 45, y + 24); // (x, y)
    pdf.text("ผู้รับมอบอำนาจ", 50, y + 29); // (x, y)
    pdf.text(`ขอแสดงความนับถือ`, 145, y + 2); // (x, y)
    pdf.addImage(oneBell, "PNG", 145, y + 3, imageWidthImg, imageHeightImg);

    pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 20); // (x, y)
    pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 24); // (x, y)
    pdf.text("ผู้ออกจดหมาย", 150, y + 29); // (x, y)
    pdf.setFont("THSarabunNew", "bold");
    pdf.text(
      `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.datetime)
        .add(543, "year")
        .format(
          "D MMMM YYYY",
        )} หากมาชำระหลังจากนี้ยอดเงินอาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
      15,
      y + 40,
    );
    pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 45); // (x, y)
  });

  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  // window.open(pdfUrl);
  return pdfUrl;
}
